import httpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { checkIsInternal } from '@src/utility/createStorage';

export interface PSMSIndicatorMetric {
  TitleId: number | string;
  CardTitle?: string;
  Category?: string | null;
  SubCategory?: string | null;
  ExternalIndicatorflag?: boolean;
}

export interface PSMSIndicatorApiResponse {
  Status: string;
  StatusCode: number;
  Message?: string;
  TimeStamp?: string;
  Data: PSMSIndicatorMetric[];
}

const _httpService = new httpService();
if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') || '');
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') || '');
}

export const getProviderMetricsIds =
  async (): Promise<PSMSIndicatorApiResponse | null> => {
    const providerPSMSInfoStr =
      sessionStorage.getItem('providerPSMSInfo') || '{}';
    const providerObj = JSON.parse(providerPSMSInfoStr);
    const ProviderEntityID = providerObj?.ProviderEntityID;
    if (!ProviderEntityID) return null;
    try {
      const response: PSMSIndicatorApiResponse = await _httpService.get(
        '/entity-metrics-ids/' + ProviderEntityID
      );
      return response;
    } catch {
      return null;
    }
  };
